const checkAddToCartError = (responseObj) => {
  var _a;
  const { orderErrMsgObj, errorMessage, customErrorLabel } = responseObj || {};
  return customErrorLabel || ((_a = Object.values(orderErrMsgObj || {})) == null ? void 0 : _a.join(". ")) || errorMessage;
};
const getActionType = (updatedQty, type, orderId) => {
  if (updatedQty === 0) {
    return "delete";
  }
  if (type === "add" || !orderId) {
    return "add";
  }
  return "update";
};
export {
  checkAddToCartError,
  getActionType
};
